import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, Notice} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {NoticesService} from '../../../services/notices.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'schedule-notice-modal',
    templateUrl: './schedule-notice-modal.component.html',
    styleUrls: ['./schedule-notice-modal.component.scss']
})
export class ScheduleNoticeModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    suites: Array<any> = [];
    listPlaylist: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: Notice = new Notice();
    disabledSubmit = false;
    startDate: string = (new Date).toISOString();
    endDate: string = (new Date).toISOString();
    time = ScheduleNoticeModalComponent.parseTime((new Date()).toISOString());
    buildingSelectIsDisabled = false;
    isEditModeNoSpinner = false;
    maxDate = new Date();
    listDuration = [
        {value: 5 , name: '5s'},
        {value: 10, name: '10s'},
        {value: 15, name: '15s'},
        {value: 20, name: '20s'},
        {value: 30, name: '30s'},
        {value: 45, name: '45s'},
        {value: 60, name: '1m'},
        {value: 90, name: '1.5m'},
        {value: 120, name: '2m'},
        {value: 180, name: '3m'},
        {value: 300, name: '5m'}
    ];
    advancedMonth = [
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false
    ];
    advancedWeekDays = [
        false, false, false,
        false, false, false,
        false, false, false,
        false
    ];
    advancedDays = [
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false
    ];
    advancedHours = [
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false,
        false, false, false
    ];

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public noticesService: NoticesService,
        public authService: AuthenticationService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.initData();
        this.initTimePicker();
        setTimeout( () => this.showModal = true, 300);
    }

    initTimePicker() {
        $('#timepicker1').timepicker().on('changeTime.timepicker', e => this.time = e.time.value);
        $('#timepicker2').timepicker().on('changeTime.timepicker', e => this.time = e.time.value);
    }

    openTimepicker(id): void {
        $(`#${id}`).timepicker('showWidget');
    }

    initData() {
        // this.getIncidentTypes();
        this.isEditModeNoSpinner = false;
        if (this.noticesService.noticeInNoticeModal) {
            this.data = this.noticesService.noticeInNoticeModal;
            this.startDate = this.data.createdAt;
            this.endDate = this.data.createdAt;
            this.time = ScheduleNoticeModalComponent.parseTime(this.data.createdAt);
            this.isEditModeNoSpinner = true;
            this.listPlaylist = [this.data.playlist];
            // this.getSuites(this.data.buildingId, this.data.suiteId);
        } else {
            const b = this.urlService.queryParams['building'];
            if (b) {
                // this.data.buildingId = b;
                // this.getSuites(this.data.buildingId);
            }

            if (this.noticesService.buildings.length === 1) {
                // this.data.buildingId = this.noticesService.buildings[0].id;
                // this.getSuites(this.data.buildingId);
            }
        }
    }

    hideModal() {
        this.noticesService.isNoticeScheduleShow = false;
        this.noticesService.noticeInNoticeModal = null;
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            // if (!form.value.buildingId) toastr.warning('Building should not be blank.');
            // if (!form.value.suiteId)    toastr.warning('Unit should not be blank.');
            // if (!form.value.residentId) toastr.warning('Resident should not be blank.');
            if (!form.value.date)       toastr.warning('Date should not be blank and must consist of valid day, month and year.');
            if (!form.value.time)       toastr.warning('Time should not be blank.');
            return;
        }
        const building = this.noticesService.buildings.find((item) => item.id == form.value.buildingId);
        const suite    = this.suites.find((item) => item.id == form.value.suiteId);
        const resident = this.residents.find((item) => item.id == form.value.residentId);
        // if (!suite)    { toastr.warning('Suite not found.');    return; }
        // if (!resident) { toastr.warning('Resident not found.'); return; }

        const data: any = {
            building: {
                bdId: form.value.buildingId ? form.value.buildingId : 0,
                name: building ? building.name : null,
            },
            suite: {
                bdId:        suite && suite.id ? form.value.suiteId : 0,
                suiteNumber: suite && suite.id ? suite.name         : form.value.otherSuite,
            },
            resident: {
                bdId:     resident && resident.id ? resident.id       : 0,
                fullName: resident && resident.id ? resident.fullName : form.value.otherResident,
            },
            incident:           form.value.incident,
            createdAt:          this.getDateTimeFromForm(),
            createdBy:          {fullName: this.authService.user.fullName, email: this.authService.user.email},
            reportedBy:         form.value.reportedBy,
            reportedArea:       form.value.reportedArea,
            incidentReportType: form.value.incidentReportType
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainIncidentReports', `/v1/incident_report/${this.data.id}.json`, data).subscribe(
                () => this.updateView('Incident Report successfully updated'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Edit Incident Report failed');
                }
            );
        } else {
            this.api.post('domainIncidentReports', '/v1/incident_report.json', data).subscribe(
                () => this.updateView('Incident Report successfully created'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Create Incident Report failed');
                }
            );
        }
    }

    getDateTimeFromForm(): Date {
        const date = new Date(this.form.value.date);
        const time = this.form.value.time;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        return date;
    }

    updateView(msg: string): void {
        toastr.success(msg);
        this.noticesService.getData();
        this.form.reset();
        this.hideModal();
    }

    changeBuilding(buildingId: string) {
        this.isEditModeNoSpinner = false;
    }

    back(): void {
        this.noticesService.isNoticeScheduleShow = false;
        this.noticesService.isNoticeModalShow = true;
        this.noticesService.step = this.noticesService.firstStep;
    }

    nextStep(): void {
        this.noticesService.isNoticeScheduleShow = false;
        this.noticesService.isNoticeInfoShow = true;
        this.noticesService.step = 'info';
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/notices/schedule-notice-modal/schedule-notice-modal.component.ts